<template>
  <v-btn icon flat small @click="selectPlayer">
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <v-icon color="primary" v-on="on">arrow_forward</v-icon>
      </template>
      <span>Seleccionar jugador</span>
    </v-tooltip>
  </v-btn>
</template>

<script>
export default {
  props: {
    player: Object // recibimos el jugador
  },

  methods: {
    selectPlayer () {
      // emitimos al padre el jugador seleccionado
      this.$emit('player-selected', this.player)
    }
  }
}
</script>
